// TODO: Fix eslint errors.
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable func-names */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-empty */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import React, { useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import { IntlProvider } from 'react-intl';
import updateSecondLevelMenuActiveLink from 'updateSecondLevelMenuActiveLink';
import Homepage from '@Pages/Homepage';
import Workforce from '@Pages/Workforce';
import Blog from '@Pages/Blog';
import Newsroom from '@Pages/Newsroom';
import Press from '@Pages/Press';
import Career from '@Pages/Career';
import NotFound from '@Pages/NotFound';
import Logger from '@ffw/logger-lib';
import SuccessStories from './pages/success-stories';

// We have to collect all routes outside the App function, because of the pageLoader.
// If we use the pageLoader inside a function, SSR wont load the components.
const routeComponents = [];
// Load the routes for the specific country.
const routesCore = require('../config/core/client.routes.json');

let routesOpCo = {};
try {
  routesOpCo = require(`../config/${process.env.REACT_APP_COUNTRY}/client.routes.json`);
} catch (e) {}
const routes = {
  ...routesCore,
  ...routesOpCo,
};

// Iterate through all supported languages for the country.
for (const lang in routes) {
  // Iterate through all supported routes and components for the country.
  for (const routeName in routes[lang]) {
    const route = routes[lang][routeName];
    let Component = null;
    switch (route.component) {
      case 'blog':
        Component = function (props) {
          return <Blog {...props} pageType={routeName} />;
        };
        break;
      case 'newsroom':
        Component = function (props) {
          return <Newsroom {...props} pageType={routeName} />;
        };
        break;
      case 'workforce':
        Component = function (props) {
          return <Workforce {...props} pageType={routeName} />;
        };
        break;
      case 'press':
        Component = function (props) {
          return <Press {...props} pageType={routeName} />;
        };
        break;
      case 'career':
        Component = function (props) {
          return <Career {...props} pageType={routeName} />;
        };
        break;
      case 'success_stories':
        Component = function (props) {
          return <SuccessStories {...props} pageType={routeName} />;
        };
        break;
      case 'homepage':
        Component = Homepage;
        break;
      default:
        break;
    }

    // Add the route in the renderable array.
    routeComponents.push(
      <Route key={routeName} path={`${route.url}`} component={Component} />,
    );
  }
}
// Everything that is not defined as route will lead to NotFound page.
routeComponents.push(<Route key="not-found" component={NotFound} />);
function App({ currentLanguage }) {
  // Get the language.
  const lang = currentLanguage || process.env.REACT_APP_DEFAULT_LANGUAGE;

  // Get the translations based on the language.
  let messages;
  try {
    messages = require(`../i18n/${process.env.REACT_APP_COUNTRY}/${lang}.json`);
  } catch (e) {
    // Use the translations from the default language if the file is missing.
    Logger.error(`Missing translation for: ${lang}`, 'App.js');
  }

  useEffect(() => {
    document.querySelector('html').classList.add('js');
  }, []);

  useEffect(() => {
    updateSecondLevelMenuActiveLink();
  }, [useLocation()]);

  return (
    <IntlProvider
      defaultLocale={process.env.REACT_APP_DEFAULT_LANGUAGE}
      locale={lang}
      messages={messages}
    >
      <Switch>{routeComponents}</Switch>
    </IntlProvider>
  );
}

export default hot(App);
